import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const BottomOptions = ({ left, right }) => (
  <div styleName="bottom">
    <div styleName="left">{left}</div>
    <div styleName="right">{right}</div>
  </div>
);

BottomOptions.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
};

BottomOptions.defaultProps = {
  left: null,
  right: null,
};

export default BottomOptions;
